export class TextosCovid19 {
  public static hogarVulnerable = "Hogar Vulnerable";
  public static adultoMayor = "Adulto Mayor";
  public static recibiendoSeguroDesempleo = "Persona percibiendo seguro de desempleo";
  public static suspensionReduccionJornada = "Suspensión o reducción de jornada laboral";
  public static trabajadorIndependiente = "Trabajador informal o independiente";
  public static institucionesOrganizaciones = "Instituciones, organizaciones sociales y microempresas";
  public static otros = "Otros perfiles de vulnerabilidad";
}